import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { LiftOrderService, BasedOn } from '../../services/lift-order.service';
import { ProductClientService } from '../../services/product-client.service';
import { QuotService } from '../../services/quot.service';

import { ISubscription, Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-display-lift-order',
  templateUrl: './display-lift-order.component.html',
  styleUrls: ['./display-lift-order.component.css']
})
export class DisplayLiftOrderComponent implements OnInit, OnDestroy {
  loading: boolean[] = [false];
  get loaded(): boolean { return !this.loading.includes(false); }

  liftOrder: any;
  liftOrderSub;
  liftOrderForm: FormGroup;
  
  basedOn: BasedOn = BasedOn.PrClient;

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: LiftOrderService,
    private prClientService: ProductClientService,
    private quotService: QuotService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.createForm();
    this.liftOrderSub = this.service.getLiftOrder(this.activatedRoute.snapshot.paramMap.get('id')).subscribe(([liftOrder]) => {
      this.liftOrder = liftOrder;
      console.log(liftOrder)
      const {basedOn=BasedOn.PrClient,prClientObj: [prClientObj]=[null],prVntaObj,quotObj} = liftOrder;
      this.liftOrderForm.get('date').patchValue(liftOrder.date);
      this.liftOrderForm.get('deliveryDate').patchValue(liftOrder.deliveryDate);
      this.liftOrderForm.get('number').patchValue(liftOrder.number);
      this.liftOrderForm.get('quantity').patchValue(liftOrder.quantity);
      this.liftOrderForm.get('pricePerUnit').patchValue(liftOrder.pricePerUnit);
      this.liftOrder.productName = basedOn == BasedOn.PrClient ? prClientObj.prVntaObj.name : prVntaObj.name;
      this.liftOrder.quotFolio = quotObj && quotObj.folio || '';

      this.liftOrder.prClientCode = prClientObj && prClientObj.code || '';
      this.liftOrder.prClientVersion = prClientObj && prClientObj.version || '';
      this.loading[0] = true;
    })
  }
	ngOnDestroy() {
    this.liftOrderSub.unsubscribe();
  }

  createForm(){
    this.liftOrderForm = this.fb.group({
      date: ['', Validators.required],
      deliveryDate: ['', Validators.required],
      number: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]],
      pricePerUnit: ['', [Validators.required, Validators.min(0)]]
    });
  }


}
